import {COMMON_BUILDING_TOKENS} from "../../../constants/tokens";
import {selectConstructionPlanState} from "../../../redux/reducers/privateStateReducer/selectors";
import {
  selectHexes,
  selectPendingBuildings,
  selectStartingQuarters,
} from "../../../redux/reducers/sharedStateReducer/selectors";
import {checkIfCentralQuarter} from "../../buildings/checkIfCentralQuarter";
import {calculateBaseQuarterAllowedCells, calculateQuarterZoneCells} from "./calculateQuarterZoneCells";
import {getConstructionMarkersState} from "./planning/buildConstructionPlanningViewState";

/**
 * Какие значки зоны кварталов стоят на поле: ячейка -> картинка. Тот же расчет, что
 * рисует слой зоны (HexGridRenderer.updateQuarterZoneOverlay)
 */
const resolveZoneMarkers = (state) => {
  const markersState = getConstructionMarkersState(state);
  const baseQuarterAllowedCells = calculateBaseQuarterAllowedCells(markersState);
  const markers = new Map();
  calculateQuarterZoneCells(markersState).forEach((cellKey) => {
    markers.set(cellKey, baseQuarterAllowedCells.has(cellKey) ? 'base_quarter_allowed' : 'quarter_zone');
  });
  return {markers, hexes: selectHexes(markersState)};
};

/** Квартал ли это: только кварталы создают зону */
export const checkIfQuarterToken = (token) => (
  token === COMMON_BUILDING_TOKENS.QUARTER || checkIfCentralQuarter(token)
);

/** Состояние до постройки: действие уже применено, остальное в партии то же самое */
export const buildStateBeforePlacement = (state, placedHexKey, hexesBefore) => {
  const placedToken = selectHexes(state)?.[placedHexKey];
  const shared = state.shared;
  return {
    ...state,
    shared: {
      ...shared,
      hexes: hexesBefore,
      gameState: {
        ...shared.gameState,
        pendingBuildings: (selectPendingBuildings(state) || [])
          .filter((building) => building.hexKey !== placedHexKey || building.token !== placedToken),
      },
    },
  };
};

/** Состояние до выбора стартового квартала: он лежит в startingQuarters, а не на поле */
export const buildStateBeforeStartingQuarter = (state, playerId) => {
  const {[playerId]: _placed, ...startingQuarters} = selectStartingQuarters(state) || {};
  return {
    ...state,
    shared: {...state.shared, gameState: {...state.shared.gameState, startingQuarters}},
  };
};

/** Состояние до постановки в план: та же партия без этой записи плана */
export const buildStateBeforePlanEntry = (state, hexKey, token) => {
  const plan = selectConstructionPlanState(state);
  return {
    ...state,
    private: {
      ...state.private,
      constructionPlan: {
        ...plan,
        entries: plan.entries.filter((entry) => entry.hexKey !== hexKey || entry.token !== token),
      },
    },
  };
};

/**
 * Ячейки, значок зоны на которых появился или сменился из-за постройки: раньше
 * квартал здесь строить было можно (значка не было или он разрешал базовый квартал),
 * а теперь на ячейке другой значок.
 *
 * @param {Object} stateBefore
 * @param {Object} stateAfter
 * @returns {Array<{cellKey: string, spriteKey: string, isOnRoad: boolean}>}
 */
export const resolveNewQuarterZoneCells = (stateBefore, stateAfter) => {
  const before = resolveZoneMarkers(stateBefore);
  const after = resolveZoneMarkers(stateAfter);
  const cells = [];
  after.markers.forEach((spriteKey, cellKey) => {
    if (before.markers.get(cellKey) !== spriteKey) {
      cells.push({cellKey, spriteKey, isOnRoad: after.hexes[cellKey] === COMMON_BUILDING_TOKENS.ROAD});
    }
  });
  return cells;
};
